import React from "react";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import { EExamInfoTabs } from "../helper";
import useStyles from "./styles";

interface IProps {
  data: EExamInfoTabs[];
  selectedTab: EExamInfoTabs;
  onSetSelectedTab: (value: EExamInfoTabs) => void;
}

const HorseInfoTabs = (props: IProps) => {
  const { data, selectedTab, onSetSelectedTab } = props;
  const classes = useStyles();

  const renderTabs = () =>
    data.map(tab => (
      <Tab key={tab} className={classes.tab} value={tab} label={tab} />
    ));

  const handleChangeTab = (event, value) => {
    onSetSelectedTab(value);
  };

  return (
    <Tabs
      className={classes.tabs}
      onChange={handleChangeTab}
      value={selectedTab}
    >
      {renderTabs()}
    </Tabs>
  );
};

export default HorseInfoTabs;
